import React from "react";
import useResponsive from "../../core/hooks/useResponsive";
import ThreeColumn from "../../core/layouts/ThreeColumn";
import { ThreeRow } from "../../core/layouts";
import variables from "../../themes/base/styles/variables";

const PlanAuditContainerLayoutStyle = {
  bottomSectionStyle: {
    marginTop: variables.marginMedium,
  },
  containerStyles: {
    flex: variables.flex1,
    overflow: "unset",
  },
  containerWrapperStyles: {
    overflow: variables.overflowUnset,
  },
};

export default function PlanOperationRepairAuditLayout({
  style,
  leftSection,
  middleSection,
  rightSection,
  headerTopSection,
}) {
  const responsive = useResponsive();

  return responsive.isSm ? (
    <ThreeColumn
      style={{ ...style, gap: variables.gapSmall, overflow: "unset" }}
      leftSection={leftSection}
      leftSectionStyle={PlanAuditContainerLayoutStyle.containerStyles}
      middleSection={middleSection}
      middleSectionStyle={PlanAuditContainerLayoutStyle.containerStyles}
      rightSection={rightSection}
      rightSectionStyle={PlanAuditContainerLayoutStyle.containerStyles}
    />
  ) : (
    <ThreeRow
      style={{ ...style, gap: variables.gapSmall }}
      topSection={leftSection}
      middleSection={middleSection}
      bottomSection={rightSection}
    />
  );
}
